import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import FormProperties from './FormProperties'
import { Grid, Box, Card } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useLocation } from 'react-router-dom'
import ConfirmDialog from 'src/views/common/ConfirmDialog'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
  const loc = useLocation()
      const onSuccessCallback = useRef((e) =>
    history.push(`${pathMap.UAE_MPCI}/edit/` + e.id)
  )

  let formikPropsData
  if (loc.state !== undefined) {
    formikPropsData = {
      ...FormProperties.formikProps,
      initialValues: loc.state,
    }
  } else {
    formikPropsData = FormProperties.formikProps
  }

  return (
    <Card>
      <Box padding={2}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={formikPropsData}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: UaeMpciApiUrls.POST,
            onSuccess: (e) => {
              showNotification('success', 'Record created successfully.')
              onSuccessCallback.current(e)
            }
          }}
          renderButtonSection={(loading) => (
            <AddPageButtonSection history={history} loading={loading} />
          )}
        />
      </Box>
    </Card>
  )
}

export default AddPage

function AddPageButtonSection(props) {
  const { history, loading } = props
  const [confirmDialog, setConfirmDialog] = useState(false)

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton
            color='primary'
            disabled={loading}
            type='submit'
            size='medium'
            shouldShowProgress={loading}
          >
            Save
          </CngButton>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.UAE_MPCI_LIST_VIEW)}
        content="All progress in this session will be lost and can't be restored. Are you sure about this?"
        okMsg='Yes, discard'
        cancelMsg='Continue editing'
        title='Discard'
      />
    </>
  )
}
